import React from "react";

import { Link } from "react-router-dom";

import {
  Container,
  Footer,
  FooterContent,
  ContactContainer,
  SocialMedias,
  SimiliarContents,
  CopyrightText,
} from "./styles";

import logoImg from "./../../assets/components/Footer/7cantos.png";

import facebook from "./../../assets/components/Footer/facebook.svg";
import instagram from "./../../assets/components/Footer/instagram.svg";
import youtube from "./../../assets/components/Footer/youtube.svg";
import whatsapp from "./../../assets/components/Footer/whatsapp.svg";

interface FooterProps {
  variant?: "default" | "dark";
}

export default function FooterComponent({ variant = "default" }: FooterProps) {
  const isDark = variant === "dark";

  return (
    <Container $isDark={isDark}>
      <Footer $isDark={isDark}>
        <FooterContent $isDark={isDark}>
          <ContactContainer $isDark={isDark}>
            <img src={logoImg} alt="logo" />
            <p>contato@7cantos.com</p>
            <p>4003-7654</p>

            <SocialMedias>
              <a href="https://www.facebook.com/7cantoss/">
                <img src={facebook} alt="facebook" />
              </a>
              <a href="https://www.instagram.com/7cantos/">
                <img src={instagram} alt="instagram" />
              </a>
              <a href="https://www.youtube.com/channel/UCYMtGV7GKhkbRJmjSDjEbjQ">
                <img src={youtube} alt="youtube" />
              </a>
              <a
                href="https://api.whatsapp.com/send/?phone=551140037654&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noreferrer"
              >
                <img src={whatsapp} alt="whatsapp" />
              </a>
            </SocialMedias>
          </ContactContainer>

          <SimiliarContents $isDark={isDark}>
            <b>IMÓVEIS</b>

            <Link to="/advertise-property" target="_blank">
              Anunciar Imóvel
            </Link>
            <Link to="/indicar-imovel">Indique & Ganhe</Link>
          </SimiliarContents>

          <SimiliarContents $isDark={isDark}>
            <b>7CANTOS</b>

            <Link to="/about-us">Sobre nós</Link>
            <a href="https://sites.google.com/7cantos.com/carreiras">Carreiras</a>
            <a href="https://decor.7cantos.com/">7Decor</a>
            <Link to="/use-terms">Termos de Uso</Link>
            <Link to="/privacy-politics">Política de Privacidade</Link>
            <Link to="/his-hmp">HIS e HMP</Link>
          </SimiliarContents>

          <SimiliarContents $isDark={isDark}>
            <b>CADASTRO</b>

            <Link to="/register">Criar conta</Link>
            <Link
              to={{
                pathname: "/login",
                state: { fromSite: true },
              }}
            >
              Fazer login
            </Link>
          </SimiliarContents>
        </FooterContent>

        <CopyrightText $isDark={isDark}>
          © Sete Cantos Serviços Imobiliários LTDA. Todos os direitos reservados.
          CRECI 1284-J.
        </CopyrightText>
      </Footer>
    </Container>
  );
}
